/**
 * Composable pour le formatage des prix
 */

/**
 * Arrondit un prix à 2 décimales (standard comptable).
 * @param {number} price
 * @returns {number}
 */
export function formatPrice(price) {
    const rounded = Math.round(parseFloat(price) * 100) / 100;
    return Object.is(rounded, -0) ? 0 : rounded;
}

export function formatPriceWithCurrency(price) {
    return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(formatPrice(price));
}

/**
 * Arrondit un prix à l'entier le plus proche selon la règle d'affichage front
 * (cf. helper PHP displayPrice) : < 0.3 de décimale → arrondi inférieur, sinon supérieur.
 * @param {number} price
 * @returns {number}
 */
export function displayPrice(price) {
    const value = parseFloat(price);
    const decimalPart = value - Math.floor(value);

    return decimalPart < 0.3 ? Math.floor(value) : Math.ceil(value);
}

/**
 * Formate un prix sans décimale (ex. affichage du prix dans le calendrier).
 */
export function formatPriceRoundedWithCurrency(price) {
    return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(displayPrice(price));
}

export function formatPriceIntl(price) {
    return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(formatPrice(price));
}

/**
 * Hook composable pour utiliser les fonctions de formatage de prix
 */
export default function usePrice() {
    return {
        formatPrice,
        formatPriceWithCurrency,
        formatPriceRoundedWithCurrency,
        formatPriceIntl,
    };
} 
